import { UserIconMenu } from '@framework/ui/elements/TopNavigation';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

type Props = {
  currentUserId: string;
};

const HEADER_HEIGHT = 64;

export const Header: React.FC<Props> = ({ currentUserId }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="border-b-2">
      <div className="flex items-center" style={{ height: HEADER_HEIGHT - 2 }}>
        <div className="relative ml-auto flex items-center justify-items-stretch gap-x-4 p-2">
          <Link to={'/'} className="text-brand">
            {t('auth.stopMail.header.topPage')}
          </Link>
          <UserIconMenu userId={currentUserId} />
        </div>
      </div>
    </div>
  );
};
